import { render, staticRenderFns } from "./MeasureContainer.vue?vue&type=template&id=165cf5df"
import script from "./MeasureContainer.vue?vue&type=script&lang=ts"
export * from "./MeasureContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports